import { getHash, renderMainView } from '../AppHeader/Link';
import { cEl } from '../../util';

function AppMain() {
    const contentContainer = cEl('section');
    contentContainer.classList.add('app-main');

    renderMainView(getHash(), contentContainer);

    return contentContainer;
}

export default AppMain;
